import { render, staticRenderFns } from "./transport-form.vue?vue&type=template&id=1ba0fd64"
import script from "./transport-form.vue?vue&type=script&lang=js"
export * from "./transport-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports